import BaseMygocuApiService from './BaseMygocuApiService';

const STAFF_API_VERSION = 'v1';
const STAFF_API_BASEPATH_URL = 'staff/' + STAFF_API_VERSION;

class StaffApiService {
  async getMisClientes() {
    return await BaseMygocuApiService.get(STAFF_API_BASEPATH_URL.concat('/misClientes'));
  }

  async getMisExperiencias() {
    return await BaseMygocuApiService.get(STAFF_API_BASEPATH_URL.concat('/misExperiencias'));
  }

  async getMisAgrupaciones() {
    return await BaseMygocuApiService.get(STAFF_API_BASEPATH_URL.concat('/misAgrupaciones'));
  }
}

export default new StaffApiService();
